import { YStack, XStack, View, Text } from 'tamagui'
import { useTranslation } from 'react-i18next'

const passwordStrength = (password: string) => {
  let score = 0
  if (password.length >= 8) score += 1
  if (/[a-z]/.test(password) && /[A-Z]/.test(password)) score += 1
  if (/\d/.test(password)) score += 1
  if (/[^a-zA-Z0-9]/.test(password)) score += 1
  return score
}

export function PasswordStrengthMeter({ password }: { password: string }) {
  const { t } = useTranslation('PasswordStrength')
  const score = passwordStrength(password)
  const levels = ['weak', 'weak', 'medium', 'good', 'strong'] as const
  const colors = [
    '$danger-300',
    '$danger-300',
    '$warning-300',
    '$success-300',
    '$success-300',
  ] as const

  if (!password) return null

  return (
    <YStack gap="$size.spacing-nano">
      <XStack gap="$size.spacing-nano">
        {[1, 2, 3, 4].map((level) => (
          <View
            key={level}
            flex={1}
            height={4}
            borderRadius={2}
            backgroundColor={score >= level ? colors[score] : '$progress-track'}
          />
        ))}
      </XStack>
      <Text
        color="$text-secondary"
        fontSize="$font-size-xxxs"
        fontFamily="$mulishRegular"
      >
        {t(levels[score])}
      </Text>
    </YStack>
  )
}
